// @flow
export { default } from './ProductContent';



// WEBPACK FOOTER //
// ./src/components/product/ProductContent/index.js